import { useCallback } from 'react'
import { useSelector, useDispatch } from 'react-redux'

export const useSelection = () => {
  const selection = useSelector((state) => state.interactions.selection)
  const dispatch = useDispatch()

  const setFunc = useCallback((value) => dispatch({
    type: 'SET_SELECTION',
    value
  }), [dispatch])

  return [
    selection,
    setFunc
  ]
}

export const useSearch = () => {
  const search = useSelector((state) => state.interactions.search)
  const dispatch = useDispatch()

  const setFunc = useCallback((value) => dispatch({
    type: 'SET_SEARCH',
    value
  }), [dispatch])

  return [
    search,
    setFunc
  ]
}

export const useHighlightedOnGraphId = () => {
  const highlightedOnGraphId = useSelector((state) => state.interactions.highlightedOnGraphId)
  const dispatch = useDispatch()

  const setFunc = useCallback((value) => dispatch({
    type: 'SET_HGLTGH_GRAPH_ID',
    value
  }), [dispatch])

  return [
    highlightedOnGraphId,
    setFunc
  ]
}

export const useHighlightedLegendItem = () => {
  const highlightedLegendItem = useSelector((state) => state.interactions.highlightedLegendItem)
  const dispatch = useDispatch()

  const setFunc = useCallback((value) => dispatch({
    type: 'SET_HGLTGH_LEGEND_ITEM',
    value
  }), [dispatch])

  return [
    highlightedLegendItem,
    setFunc
  ]
}
